import React from 'react';
//TODO: Create 404 page
export const NotFoundPage: React.FC = () => <>Siden finnes ikke</>;
